import { useState } from "react";

import NetcompanyDesktop from "./NetcompanyDesktop";
import OptimizerDesktop from "./OptimizerDesktop";
import ArrowRight from "../LogoSVG/ArrowRight";
import TeknikDesktop from "./TeknikDesktop";

function ExperienceDesktop() {
  const [hoveredIndex, setHoveredIndex] = useState<number>();
  const [hoverArrow, setHoverArrow] = useState<boolean>(false);

  return (
    <section id="experience" className="pt-[80px] mb-[60px]">
      <div className="container">
        <div className="flex items-center">
          <p className="text-[24px] font-medium mb-8">Experience</p>
        </div>

        <div>
          <NetcompanyDesktop
            index={1}
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
          />
          <OptimizerDesktop
            index={2}
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
          />
          <TeknikDesktop
            index={3}
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
          />
        </div>
      </div>
    </section>
  );
}

export default ExperienceDesktop;
